module.exports = __webpack_public_path__ + "static/media/dawn-patrol.7af7cded.webp";